<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">Preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Tipo de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5 mb-3">
    <div class="col">
      <h3>Listado de rubros</h3>
      <p>Agregar las preguntas que llevaran los rubros</p>
    </div>
    <div class="col text-right">
      <button
      *ngIf="bloques"
      [disabled]="!validBtnContinue()"
        type="button"
        class="btn btn-sm btn-primary"
        routerLink="../../../ChecklistPaso4/{{ idChecklist }}/{{
          idTipoRevision
        }}"
      >
        <i class="fa fa-arrow-right"></i> Continuar
      </button>
    </div>
  </div>

  <div class="card mt-2" *ngFor="let bloque of bloques">
    <div class="card-body">
      <h3 class="card-title">{{ bloque.Nombre }}</h3>

      <div id="accordion{{ bloque.IdBloque }}">
        <div class="card mb-1" *ngFor="let rubro of bloque.Rubros">
          <div
            class="card-header"
            id="heading{{ rubro.IdRubro }}"
            aria-expanded="true"
            style="cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + rubro.IdRubro"
            [attr.aria-controls]="'collapse' + rubro.IdRubro"
          >
            <div class="row">
              <div class="col-md-9">
                <h6 class="mb-0">{{ rubro.Nombre }}</h6>
              </div>
            </div>
          </div>
          <div
            id="collapse{{ rubro.IdRubro }}"
            class="collapse"
            [attr.aria-labelledby]="'heading' + rubro.IdRubro"
            [attr.data-parent]="'#accordion' + bloque.IdBloque"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <h6>Preguntas</h6>
                </div>
                <div class="col text-right">
                  <button
                    class="btn btn-sm btn-primary rounded-circle"
                    (click)="newPreguntaClick(rubro.IdRubro, rubro.Preguntas)"
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h6>
                    Ponderación Total: {{ sumaPonderaciones(rubro.Preguntas) }} / 100
                  </h6>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Orden</th>
                          <th scope="col">Pregunta</th>
                          <th scope="col">Requiere evidencia</th>
                          <th scope="col">Requiere comentario</th>
                          <th scope="col">Ponderación</th>
                          <th scope="col">Editar</th>
                          <th scope="col">Eliminar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let pregunta of rubro.Preguntas">
                          <td>{{ pregunta.Orden }}</td>
                          <td>{{ pregunta.Descripcion }}</td>
                          <td>
                            <ul class="tg-list">
                              <li class="tg-list-item">
                                <input
                                  (click)="reqEvidenciaClick(pregunta)"
                                  class="tgl tgl-ios"
                                  id="cb{{ pregunta.IdPregunta }}"
                                  type="checkbox"
                                  bind-checked="pregunta.FlagEvidencia"
                                />
                                <label
                                  class="tgl-btn"
                                  for="cb{{ pregunta.IdPregunta }}"
                                ></label>
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="tg-list">
                              <li class="tg-list-item">
                                <input
                                  (change)="
                                    reqComentarioClick($event, pregunta)
                                  "
                                  class="tgl tgl-ios"
                                  id="cbComentario{{ pregunta.IdPregunta }}"
                                  type="checkbox"
                                  bind-checked="pregunta.FlagComentario"
                                />
                                <label
                                  class="tgl-btn"
                                  for="cbComentario{{ pregunta.IdPregunta }}"
                                ></label>
                              </li>
                            </ul>
                          </td>
                          <td>{{ pregunta.Ponderacion }}</td>
                          <td style="text-align: center">
                            <button
                              type="button"
                              class="btn btn-sm btn-primary btn-sm rounded-circle"
                              (click)="
                                editPreguntaClick(
                                  pregunta,
                                  pregunta.Ponderacion,
                                  rubro.Preguntas
                                )
                              "
                            >
                              <i class="fa fa-pencil"></i>
                            </button>
                          </td>
                          <td style="text-align: center">
                            <button
                              type="button"
                              class="btn btn-danger btn-sm rounded-circle"
                              (click)="
                                deletePreguntaClick(
                                  pregunta.IdRubro,
                                  pregunta.IdPregunta
                                )
                              "
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade configuracion"
  id="modalNewPregunta"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalEditLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <app-form-new-question
      (saveQuestionChild)="saveEditQuestion($event)"
      [totalPonderaciones]="totalPonderaciones"
      [preguntaEdit]="preguntaEdit"
    />
  </div>
</div>
